// extracted by css-extract-rspack-plugin
var _1 = "column-name-QVmnfL";
var _2 = "column-name-QVmnfL";
var _3 = "details-f_mA09";
var _4 = "form-ez6CK1";
var _5 = "query-buttons-R1W9UM";
var _6 = "query-buttons-R1W9UM";
var _7 = "table-tfzkmN";
export { _1 as "column-name", _2 as "columnName", _3 as "details", _4 as "form", _5 as "query-buttons", _6 as "queryButtons", _7 as "table" }
